import { searchAPI } from '@backmarket/http-api'
import type { AlgoliaAPIHit } from '@backmarket/http-api/src/api-specs-search-reco/search'
import { useHttpFetch } from '@backmarket/nuxt-module-http/useHttpFetch'

export const getHighlightedTitleFromSearch = (suggestion: AlgoliaAPIHit) =>
  // eslint-disable-next-line no-underscore-dangle
  suggestion?._highlightResult?.title?.value ?? ''

export const getSearchApiKey = async (indexType: string) => {
  const { data, error } = await useHttpFetch(searchAPI.getApiKey, {
    pathParams: { index: indexType },
  })

  if (error.value || !data.value?.apiKey) {
    return { apiKey: '', indexType: '' }
  }

  return data.value
}

export const getSearchConfiguration = async (scope: string) => {
  const { data, error } = await useHttpFetch(
    searchAPI.getConfigurationByScope,
    {
      pathParams: { scope },
    },
  )

  if (error.value || !data.value?.indexType) {
    return {
      facets: [],
      indexes: { active: { name: '', title: '', queryParams: {} } },
      indexType: '',
    }
  }

  return data.value
}
